export default "__VITE_ASSET__D8XaEgOc__"